<template>
    <div id="contact">
        <el-main class="contact-section">
            <el-row align="middle" justify="center">
                <el-col :span="8">
                    <h4>产品中心</h4>
                    <p>
                        <el-link href="https://www.tecochina.net/" target="_blank">东元</el-link>
                    </p>
                    <p>贝得</p>
                    <p>茵梦达</p>
                    <p>西门子</p>
                    <p>ABB电机</p>
                </el-col>
                <el-col :span="8">
                    <h4>联系我们</h4>
                    <p>请通过以下方式联系我们，了解更多信息。</p>
                    <p>网址：
                        <el-link href="http://www.dsxtech.cn" target="_blank" type="primary">
                            https://www.dsxtech.cn
                        </el-link>
                    </p>
                    <p>电话：+86-181-2158-9080</p>
                    <p>邮箱：postmaster@dsxtech.cn</p>
                    <p>地址：上海市嘉定区墨玉南路1080号</p>
                </el-col>
                <el-col :span="8">
                    <p>微信扫码，成为好友</p>
                    <el-image :src="codeImg" style="width: 180px; height: 180px"/>
                </el-col>
            </el-row>
        </el-main>
    </div>
</template>

<script setup>
import {ref} from "vue";
import qrcode from '@/assets/qrcode.png';

const codeImg = ref(qrcode)
</script>

<style scoped>
.contact-section {
    padding: 50px 250px;
    text-align: left;
    background-color: #eceef4;
}

.el-col p {
    font-size: 14px;
    color: #322a2a;
    margin-bottom: 10px;
}
</style>